import { useState, useEffect } from 'react';

function isPlatformIOS() {
  if (typeof navigator === "undefined") {
    return false;
  }
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || // iPad on iOS 13 detection
  navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
function usePlatformIOS() {
  const [isMatch, setIsMatch] = useState(false);
  useEffect(() => {
    setIsMatch(isPlatformIOS());
  }, []);
  return isMatch;
}

export { isPlatformIOS, usePlatformIOS };
//# sourceMappingURL=platform.is-ios.js.map
